import _ from "lodash";
import PropTypes from "prop-types";
import React, { useContext } from "react";
import { createUseStyles } from "react-jss";
import { StyleTypeContext, CurrencyContext } from "../../umbilical_tools";
import CurrencySelectorModal from "./CurrencySelectorModal";
import { getCurrency } from "./helpers";
import { InlineIcon } from "@iconify/react";
import jssVariables from "../../jss_setup";
import { Button } from "../common/Button";

const currencyBtnStyles = {
  ButtonReverted: {
    paddingRight: jssVariables.half_gap,
    paddingLeft: jssVariables.half_gap,
  },
  label: {
    display: "grid",
    gridTemplateColumns: "max-content max-content",
    gridGap: ".2rem",
    alignItems: "center",
  },
};
const styles = createUseStyles({
  CurrencySelector: (props) => ({
    display: "grid",
    gridTemplateColumns: "max-content max-content",
    justifyItems: "center",
    ..._.get(props.customStyles, "CurrencySelector", {}),
  }),
  titleContainer: (props) => ({
    cursor: "pointer",
    display: "grid",
    gridTemplateColumns: "max-content max-content",
    alignItems: "center",
    ..._.get(props.customStyles, "titleMobile", {}),
  }),
  titleMobile: (props) => ({
    display: "block",
    cursor: "pointer",
    color: "white",
    fontSize: "xx-large",
    marginRight: ".5rem",
    ..._.get(props.customStyles, "titleMobile", {}),
  }),
  currencySymbol: (props) => ({
    cursor: "pointer",
    fontSize: "large",
    overflow: "hidden",
    color: "white!important",
    ..._.get(props.customStyles, "currencySymbol", {}),
  }),
  textButton: (props) => ({
    display: "grid",
    gridTemplateColumns: "max-content max-content",
    gridGap: jssVariables.half_gap,
    alignItems: "center",
    ..._.get(props.customStyles, "textButton", {}),
  }),
  [`@media ${jssVariables.media.smallscreen}`]: {
    CurrencySelector: (props) => ({
      display: "grid",
      ..._.get(props.customStyles, "CurrencySelector.smallscreen", {}),
    }),
    titleMobile: (props) => ({
      display: "none",
      ..._.get(props.customStyles, "titleMobile.smallscreen", {}),
    }),
    currencySymbol: (props) => ({
      ..._.get(props.customStyles, "currencySymbol.smallscreen", {}),
    }),
  },
});
const CurrencySelector = ({ showCurrencyModal, setShowCurrencyModal }) => {
  const { type, brand, cStyler } = useContext(StyleTypeContext);
  const { currency } = useContext(CurrencyContext);

  const classes = styles({
    customStyles: cStyler({ type, brand, objName: "lngSelector" }),
  });

  return (
    <div className={classes.CurrencySelector}>
      {currency === "ZAR" ? (
        <React.Fragment>
          <strong
            className={classes.currencySymbol}
            onClick={() => setShowCurrencyModal(true)}>
            R
          </strong>
          <strong>{currency}</strong>
        </React.Fragment>
      ) : (
        <Button
          text={
            <div className={classes.textButton}>
              <InlineIcon
                icon={getCurrency(currency)}
                onClick={() => setShowCurrencyModal(true)}
              />
              <strong>{currency}</strong>
            </div>
          }
          revert={true}
          onClick={() => setShowCurrencyModal(true)}
          customStyles={currencyBtnStyles}
        />
      )}
      {showCurrencyModal && (
        <CurrencySelectorModal
          showModal={showCurrencyModal}
          closeCurrencyModal={() => setShowCurrencyModal(false)}
        />
      )}
    </div>
  );
};
CurrencySelector.defaultProps = {
  txtLogo: false,
  showCurrencyModal: false,
};
CurrencySelector.propTypes = {
  txtLogo: PropTypes.bool.isRequired,
  showCurrencyModal: PropTypes.bool.isRequired,
  setShowCurrencyModal: PropTypes.func.isRequired,
};

export default CurrencySelector;
